import { render, staticRenderFns } from "./ContractorNote.vue?vue&type=template&id=e76b8c96&scoped=true"
import script from "./ContractorNote.vue?vue&type=script&lang=ts"
export * from "./ContractorNote.vue?vue&type=script&lang=ts"
import style0 from "./ContractorNote.vue?vue&type=style&index=0&id=e76b8c96&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76b8c96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e76b8c96')) {
      api.createRecord('e76b8c96', component.options)
    } else {
      api.reload('e76b8c96', component.options)
    }
    module.hot.accept("./ContractorNote.vue?vue&type=template&id=e76b8c96&scoped=true", function () {
      api.rerender('e76b8c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/ContractorNote.vue"
export default component.exports